module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Connect LMS',
      "size": 'lg',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.backToIntegrationsList()
      }
    }
  }, [_c('div', {
    staticClass: "mt-5 px-7 flex font-semibold"
  }, [_c('img', {
    staticClass: "rounded-full",
    staticStyle: {
      "height": "30px",
      "width": "30px"
    },
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-lg ml-3"
  }, [_vm._v("\n      " + _vm._s(_vm.provider.provider_name ?
    _vm.provider.provider_name :
    _vm.integration_connected.provider_name) + "\n    ")])]), _vm._v(" "), (!_vm.students_tab) ? _c('div', {
    staticClass: "px-7"
  }, [_c('h5', {
    staticClass: "mt-3 mb-1 text-sm text-gray-500"
  }, [_vm._v("\n      Which " + _vm._s(_vm.provider.provider_name) + " class do you want to connect to\n      " + _vm._s(_vm.getCourseDetail.title) + " in Parlay?\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-7 flex-grow overflow-y-auto"
  }, [(_vm.loading || _vm.import_students_loading) ? [_c('div', {
    staticClass: "w-100 mt5 flex justify-center"
  }, [_c('pl-spinner', {
    staticClass: "x1"
  })], 1)] : [(!_vm.students_tab) ? _c('div', {
    staticClass: "select-classroom"
  }, [_c('pl-select', {
    staticClass: "mb-4",
    attrs: {
      "options": _vm.courses,
      "label": "name",
      "selected": _vm.selected_course,
      "arrow": true,
      "placeholder": 'Select a Classroom'
    },
    on: {
      "change": function($event) {
        return _vm.getCourseUsers($event)
      }
    }
  })], 1) : _c('div', [(_vm.students && _vm.students.length) ? _c('div', {
    key: _vm.$store.state.isReloadComponent
  }, [_c('div', {
    staticClass: "my-3 text-base"
  }, [_vm._v("Select Students")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-3"
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v("Available")]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-80 p-3 border border-gray-100 rounded overflow-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_available),
      expression: "search_string_available"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_available)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_available = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sorted_available_list && _vm.sorted_available_list.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAll($event)
      }
    },
    model: {
      value: (_vm.is_all_selected),
      callback: function($$v) {
        _vm.is_all_selected = $$v
      },
      expression: "is_all_selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n                    " + _vm._s(_vm.is_all_selected ? 'De-select All' : 'Select All') + "\n                  ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_available_list), function(student) {
    return _c('div', {
      key: student.id,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": _vm.handleSelectStudent
      },
      model: {
        value: (student.selected),
        callback: function($$v) {
          _vm.$set(student, "selected", $$v)
        },
        expression: "student.selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v("\n                    " + _vm._s(student.name) + "\n                  ")])], 1)
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 my-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.students_selected_for_invite_ids.length
    },
    on: {
      "click": _vm.inviteStudents
    }
  }, [_vm._v("\n                Invite\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v("Invited")]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-80 max-h-full p-3 border border-gray-100 rounded overflow-auto"
  }, [_c('div', {
    staticClass: "mb-2 bg-white border rounded border-gray-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_string_invited),
      expression: "search_string_invited"
    }],
    staticClass: "p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_string_invited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_string_invited = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sorted_invited_list.length) ? _c('div', {
    staticClass: "flex flex-nowrap"
  }, [_c('pl-checkbox', {
    attrs: {
      "checkBoxClass": "checkmark-red",
      "disabled": _vm.remove_student_mode
    },
    on: {
      "change": function($event) {
        return _vm.handleSelectAllUninvite($event)
      }
    },
    model: {
      value: (_vm.is_all_selected_invited),
      callback: function($$v) {
        _vm.is_all_selected_invited = $$v
      },
      expression: "is_all_selected_invited"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v("\n                    " + _vm._s(_vm.is_all_selected_invited ? 'De-select All' : 'Select All') + "\n                  ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.sorted_invited_list), function(student, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-nowrap my-2"
    }, [_c('pl-checkbox', {
      attrs: {
        "checkBoxClass": "checkmark-red",
        "disabled": _vm.remove_student_mode
      },
      on: {
        "change": _vm.handleSelectStudentUninvite
      },
      model: {
        value: (student.selected),
        callback: function($$v) {
          _vm.$set(student, "selected", $$v)
        },
        expression: "student.selected"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(" " + _vm._s(student.name) + " ")])], 1)
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 my-2 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.students_selected_for_available_ids.length
    },
    on: {
      "click": _vm.removeStudents
    }
  }, [_vm._v("\n                Remove\n              ")])])])]) : _c('div', {
    staticClass: "font-semibold"
  }, [_vm._v("\n          There are no students in the course you are trying to connect. Want\n          to connect anyway? Click finish.\n        ")])])]], 2), _vm._v(" "), _c('footer', {
    staticClass: "absolute bottom-0 w-full flex items-center justify-end py-5 px-7"
  }, [(!_vm.students_tab) ? _c('div', {
    staticClass: "flex"
  }, [(!_vm.students_tab) ? _c('button', {
    staticClass: "px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-500 font-semibold mr-2.5",
    on: {
      "click": function($event) {
        return _vm.backToIntegrationsList()
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.integration_connected || _vm.connected_without_choose_course) ? _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.selected_course || _vm.import_students_loading
    },
    on: {
      "click": _vm.inviteStudents
    }
  }, [_vm._v("\n        Done\n      ")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-65614e76!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationModal.vue
// module id = 2215
// module chunks = 61